export const SET_LOCALE = "SET_LOCALE";
export const SHOWLOADER = 'SHOW_LOADER';
export const HIDELOADER = 'HIDE_LOADER';
export const LOG_IN_SUCCESS = 'LOG_IN_SUCCESS';
export const LOG_IN_FAILURE = 'LOG_IN_FAILURE';
export const COMPANY_LOAD_SUCCESS = 'COMPANY_LOAD_SUCCESS';
export const COMPANY_LOAD_FAILURE = 'COMPANY_LOAD_FAILURE';
export const LOG_OUT = 'LOG_OUT';
export const CLIENT_DETAIL_SUCCESS = 'CLIENT_DETAIL_SUCCESS';
export const LOAD_NAVIGATION_ROUTES = 'LOAD_NAVIGATION_ROUTES';
export const UN_LOAD_NAVIGATION_ROUTES = 'UN_LOAD_NAVIGATION_ROUTES';
export const CLIENT_DETAIL_FAIL = 'CLIENT_DETAIL_FAIL';
export const CLIENT_DETAIL_RESET = 'CLIENT_DETAIL_RESET';
export const CLIENT_REDIRECT = 'CLIENT_REDIRECT';
export const CLIENT_SCORE_SUMMARY = 'CLIENT_SCORE_SUMMARY';
export const CLIENT_SCORE_SUMMARY_RESET = 'CLIENT_SCORE_SUMMARY_RESET';
export const CLIENT_SMMARY_LOAN = 'CLIENT_SUMMARY_LOAN';
export const CLIENT_SUMMARY_LOAN_RESET = 'CLIENT_SUMMARY_LOAN_RESET';
export const SET_UPLOAD_FILE = 'SET_UPLOAD_FILE'
export const SET_UPLOAD_PROGRESS = 'SET_UPLOAD_PROGRESS';
export const  SUCCESS_UPLOAD_FILE = 'SUCCESS_UPLOAD_FILE';
export const FAILURE_UPLOAD_FILE = 'FAILURE_UPLOAD_FILE';
export const CLOSE_UPLOAD_FILE = 'CLOSE_UPLOAD_FILE';
export const RESET_UPLOAD_FILE = 'RESET_UPLOAD_FILE';
export const SALES_SUMMARY_CURRENT_PAYMENT = 'SUMMARY_CURRENT_PAYMENT';
export const SALES_SUMMARY_CURRENT_PAYMENT_RESET = 'SUMMARY_CURRENT_PAYMENT_RESET';
export const SALES_SUMMARY_CALCULATOR_SETTING = 'SALES_SUMMARY_CALCULATOR_SETTING';
export const SALES_SUMMARY_CALCULATOR_SETTING_RESET = 'SALES_SUMMARY_CALCULATOR_SETTING_RESET';
export const CLIENT_TAGS_RESET = 'CLIENT_TAGS_RESET';
export const CLIENT_TAGS_LOAD = 'CLIENT_TAGS_LOAD';  
export const CLIENT_HEADER_TERM = 'CLIENT_HEADER_TERM'; 
export const CLIENT_HEADER_PURCHASE_STATUS = 'CLIENT_HEADER_PURCHASE_STATUS'; 
export const CLIENT_HEADER_ENROLLED_SERVICES = 'CLIENT_HEADER_ENROLLED_SERVICES';  
export const CLIENT_HEADER_INCOME = 'CLIENT_HEADER_INCOME';
export const CLIENT_HEADER_EXPENSES = 'CLIENT_HEADER_EXPENSES';
export const CLIENT_HEADER_LAST_NOTE_DATE = 'CLIENT_HEADER_LAST_NOTE_DATE';
export const CLIENT_HEADER_NEXT_APPOINTMENT_DATE = 'CLIENT_HEADER_NEXT_APPOINTMENT_DATE';
export const CLIENT_HEADER_DETAIL_RESET = 'CLIENT_HEADER_DETAIL_RESET';
export const DM_CLIENT_DETAIL_SUCCESS = 'DM_CLIENT_DETAIL_SUCCESS';


















